import React from 'react';
import { AppstoreOutlined, CheckCircleFilled } from '@ant-design/icons';
import './StrategyCategorySelector.css';

function CategoryPanelShell({ title, badge, children, ariaLabel = 'ISIN category' }) {
  return (
    <section className="strategy-category-panel" aria-label={ariaLabel}>
      <div className="strategy-category-panel__header">
        <div className="strategy-category-panel__heading">
          <AppstoreOutlined className="strategy-category-panel__icon" aria-hidden />
          <div>
            <span className="strategy-category-panel__eyebrow">ISIN Category</span>
            <h2 className="strategy-category-panel__title">{title}</h2>
          </div>
        </div>
        {badge}
      </div>
      {children}
    </section>
  );
}

function CategoryCriteria({ criteria, standalone = false }) {
  if (!criteria) return null;
  return (
    <div className={`strategy-category-detail${standalone ? ' strategy-category-detail--standalone' : ''}`}>
      <p className="strategy-category-detail__label">Selection criteria</p>
      <p className="strategy-category-detail__criteria">{criteria}</p>
    </div>
  );
}

export default function StrategyCategorySelector({
  categories = [],
  activeKey,
  onChange,
  categoryInfo = null,
}) {
  const hasMultiple = categories.length >= 2;
  const singleCategory = categories.length === 1 ? categories[0] : categoryInfo;

  if (!hasMultiple && !singleCategory) return null;

  if (hasMultiple) {
    const active = categories.find((c) => c.categoryKey === activeKey) || categories[0];

    return (
      <CategoryPanelShell
        title="Choose a bond category to explore"
        badge={(
          <span className="strategy-category-panel__badge">
            {categories.length} options
          </span>
        )}
        ariaLabel="ISIN category selection"
      >
        <div className="strategy-category-grid" role="tablist" aria-label="ISIN categories">
          {categories.map((cat) => {
            const isActive = cat.categoryKey === activeKey;
            return (
              <button
                key={cat.categoryKey}
                type="button"
                role="tab"
                aria-selected={isActive}
                className={`strategy-category-card${isActive ? ' is-active' : ''}`}
                onClick={() => onChange?.(cat.categoryKey)}
              >
                <span className="strategy-category-card__top">
                  <span className="strategy-category-card__name">{cat.name}</span>
                  {isActive && (
                    <CheckCircleFilled className="strategy-category-card__check" aria-hidden />
                  )}
                </span>
                <span className="strategy-category-card__preview">{cat.criteria}</span>
              </button>
            );
          })}
        </div>
        <CategoryCriteria criteria={active?.criteria} />
      </CategoryPanelShell>
    );
  }

  return (
    <CategoryPanelShell
      title={singleCategory.name}
      ariaLabel="ISIN category description"
    >
      <CategoryCriteria criteria={singleCategory.criteria} standalone />
    </CategoryPanelShell>
  );
}
